export const hasMetricCardValue = (data) => (
  data?.value !== null && data?.value !== undefined
);

export const shouldShowMetricCardSkeleton = (isLoading, data) => (
  Boolean(isLoading) && !hasMetricCardValue(data)
);